export const EVoucherStatus = {
  ANY: "ANY",
  SU: "SU",
  BL: "BL",
  RF: "RF",
  CA: "CA",
  CO: "CO",
  UD: "UD",
  AC: "AC",
};
